(function () {
  'use strict';
  function createProductRail(panel, options = {}) {
    const rail = panel.querySelector('[data-look-products]');
    const toggle = panel.querySelector('[data-look-products-toggle]');
    const page = panel.ownerDocument;
    const win = page.defaultView;
    const motion = options.motion || win.matchMedia('(prefers-reduced-motion: reduce)');
    const playback = options.playback || (win.homeFeaturedRailPlayback ||= { paused: false });
    const requestFrame = options.requestFrame || win.requestAnimationFrame.bind(win);
    const cancelFrame = options.cancelFrame || win.cancelAnimationFrame.bind(win);
    const setTimer = options.setTimer || win.setTimeout.bind(win);
    const clearTimer = options.clearTimer || win.clearTimeout.bind(win);
    const Observer = options.Observer || win.IntersectionObserver;
    const Resizer = options.Resizer || win.ResizeObserver;
    const playbackEvent = 'home:featured-rail-playback-change';
    let frame = null, previous = null, position = rail.scrollLeft, direction = 1;
    let visible = !Observer, hovering = false, focused = false, manual = false, disposed = false;
    let pointer = null, suppressClick = false, clickReset = null;
    const clearClickReset = () => { if (clickReset !== null) clearTimer(clickReset); clickReset = null; };
    const maximum = () => Math.max(0, rail.scrollWidth - rail.clientWidth);
    const canMove = () => !disposed && !panel.hidden && visible && !page.hidden && !motion.matches && !playback.paused && !hovering && !focused && !manual && !pointer && maximum() > 1;
    const stop = () => {
      if (frame !== null) cancelFrame(frame);
      frame = previous = null;
      rail.dataset.lookProductsPlaying = 'false';
    };
    const tick = time => {
      frame = null;
      if (!canMove()) { stop(); return; }
      if (previous !== null) {
        position = Math.max(0, Math.min(maximum(), position + direction * Math.min(time - previous, 64) * .015));
        rail.scrollLeft = position;
        if (position >= maximum()) direction = -1;
        if (position <= 0) direction = 1;
      }
      previous = time;
      rail.dataset.lookProductsPlaying = 'true';
      frame = requestFrame(tick);
    };
    const refresh = () => {
      stop();
      const overflow = maximum() > 1;
      rail.dataset.lookProductsOverflow = String(overflow);
      if (toggle) {
        toggle.hidden = !overflow || motion.matches;
        toggle.textContent = playback.paused || manual ? 'Play' : 'Pause';
        toggle.setAttribute('aria-label', playback.paused || manual ? 'Play all product carousels' : 'Pause all product carousels');
      }
      position = rail.scrollLeft;
      if (canMove()) frame = requestFrame(tick);
    };
    const pauseManual = () => { manual = true; refresh(); };
    const onPlayback = () => { manual = false; refresh(); };
    const onToggle = () => {
      playback.paused = !(playback.paused || manual);
      manual = false;
      page.dispatchEvent(new win.Event(playbackEvent));
      refresh();
    };
    const onDown = event => {
      manual = true; suppressClick = false; clearClickReset();
      if (event.pointerType === 'mouse' && event.button === 0) pointer = { id: event.pointerId, x: event.clientX, left: rail.scrollLeft };
      refresh();
    };
    const onMove = event => {
      if (!pointer || event.pointerId !== pointer.id) return;
      const distance = event.clientX - pointer.x;
      if (Math.abs(distance) > 6) { suppressClick = true; rail.dataset.lookProductsDragging = 'true'; }
      if (suppressClick) { rail.scrollLeft = pointer.left - distance; event.preventDefault(); }
    };
    const onUp = event => {
      if (pointer && event.pointerId === pointer.id) {
        pointer = null; rail.dataset.lookProductsDragging = 'false';
        if (event.type === 'pointercancel') suppressClick = false;
        else if (suppressClick) clickReset = setTimer(() => { suppressClick = false; clickReset = null; }, 0);
        refresh();
      }
    };
    const onClick = event => { clearClickReset(); if (suppressClick) { event.preventDefault(); event.stopPropagation(); suppressClick = false; } };
    const onDrag = event => event.preventDefault();
    const onEnter = () => { hovering = true; refresh(); };
    const onLeave = () => { hovering = false; refresh(); };
    const onFocus = () => { focused = true; refresh(); };
    const onBlur = event => { focused = rail.contains(event.relatedTarget); refresh(); };
    const observer = Observer ? new Observer(entries => { visible = entries.some(e => e.isIntersecting && e.intersectionRatio >= .1); refresh(); }, { threshold: .1 }) : null;
    const resize = Resizer ? new Resizer(refresh) : null;
    observer?.observe(rail); resize?.observe(rail);
    const events = { pointerdown: onDown, pointerenter: onEnter, pointerleave: onLeave, touchstart: pauseManual, wheel: pauseManual, keydown: pauseManual, focusin: onFocus, focusout: onBlur, dragstart: onDrag, click: onClick };
    Object.entries(events).forEach(([type, handler]) => rail.addEventListener(type, handler, { capture: type === 'click', passive: type === 'touchstart' || type === 'wheel' }));
    win.addEventListener('pointermove', onMove, { passive: false });
    win.addEventListener('pointerup', onUp); win.addEventListener('pointercancel', onUp);
    page.addEventListener('visibilitychange', refresh); page.addEventListener(playbackEvent, onPlayback);
    motion.addEventListener('change', refresh); toggle?.addEventListener('click', onToggle);
    refresh();
    return { refresh, destroy() {
      disposed = true; stop(); clearClickReset(); pointer = null; suppressClick = false;
      rail.dataset.lookProductsDragging = 'false';
      observer?.disconnect(); resize?.disconnect();
      Object.entries(events).forEach(([type, handler]) => rail.removeEventListener(type, handler, { capture: type === 'click' }));
      win.removeEventListener('pointermove', onMove); win.removeEventListener('pointerup', onUp); win.removeEventListener('pointercancel', onUp);
      page.removeEventListener('visibilitychange', refresh); page.removeEventListener(playbackEvent, onPlayback);
      motion.removeEventListener('change', refresh); toggle?.removeEventListener('click', onToggle);
    } };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { createProductRail };
  if (typeof window !== 'undefined') window.createBfLookProductRail = createProductRail;
}());
